// components/Header.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { FaGamepad, FaGooglePlay, FaApple } from "react-icons/fa";

const LandingPageHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setIsScrolled(latest > 50);
  });

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.header
      className={`fixed w-full py-4 px-2 md:px-6 flex flex-col md:flex-row md:justify-between md:items-center z-50 transition-colors duration-300 ${
        isScrolled ? "bg-gray-900/95 backdrop-blur-lg" : "bg-transparent"
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Left + Middle for mobile */}
      <div className="flex flex-col items-center text-center sm:flex-row sm:text-left sm:items-center sm:gap-10">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2 group"
          onClick={handleLogoClick}
        >
          <motion.div
            whileHover={{ rotate: 360 }}
            transition={{ duration: 0.8 }}
          >
            <FaGamepad className="text-3xl text-cyan-400" />
          </motion.div>
          <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
            Twepple Kids
          </span>
        </Link>

        {/* Tagline below logo on mobile */}
        <p className="mt-2 sm:mt-0 text-sm sm:text-base md:text-lg font-medium text-gray-200">
          Where <span className="text-cyan-300 font-semibold">Curiosity</span>{" "}
          Meets{" "}
          <span className="text-purple-300 font-semibold">Creativity</span>
        </p>
      </div>

      {/* Right: Download Buttons */}
      <div className="flex md:flex-row gap-3 mt-3 md:mt-0 justify-center md:justify-start">
        <a
          href="https://play.google.com/store/apps/details?id=com.twepple.baby.toddler.kids.preschool.learning.activity.games&hl=en_USr"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-white text-sm bg-green-600 hover:bg-green-700 shadow-md shadow-green-500/30 transform hover:scale-105 transition-transform"
        >
          <FaGooglePlay className="text-lg" /> Play Store
        </a>
        <a
          href="https://apps.apple.com/us/app/kids-games-for-toddlers-2-to-6/id6736658511"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-gray-600 hover:bg-gray-700 text-white text-sm shadow-md shadow-gray-500/30 transform hover:scale-105 transition-transform"
        >
          <FaApple className="text-lg" /> App Store
        </a>
      </div>
    </motion.header>
  );
};

export default LandingPageHeader;
